(function(angular){
	'use strict';
	
	angular
		.module('formValidationModule')
		.directive('ngMin', ['FormValidationFactory', ngMinFunction]);
	
	function ngMinFunction(FormValidationFactory) {
		return {
			require: '?ngModel',
			restrict: 'A',
			link: function($scope, $elem, $attrs, ngModel) {

				$scope.$watch($attrs.ngMin, function(newValue) {
					FormValidationFactory.publishErrorVarsToModel({
						min: newValue
					}, ngModel);
				});
			}
		};
	}

})(window.angular);